export default "__VITE_ASSET__CbEUVpdh__"